<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { CriterionEditorViewModel } from "@Criteria/Hierarchies/Components/CriterionEditor";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class CriterionEditor extends Vue
    {
        get vm(): CriterionEditorViewModel { return this.$props.viewModel as CriterionEditorViewModel; }

        get opened(): boolean { return this.vm?.opened ?? false; }

        get criterionId(): number { return this.vm.criterionId; }
        get isGoal(): boolean { return this.vm.isGoal; }
        get nameError(): string | null { return this.vm.nameError; }

        emitDeleteCriterion()
        {
            this.$emit("delete-criterion", this.criterionId);
        }

        emitUpdateCriterion()
        {
            this.vm.clearValidationErrors();
            this.$emit("update-criterion", this.criterionId, this.vm.name, this.vm.description);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit criterion</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="criterion-editor-form" @submit.prevent="emitUpdateCriterion">
                            <div class="form-group">
                                <label>Name <span style="color: red;">*</span></label>
                                <input v-model.trim="vm.name" type="text" class="form-control" required minlength="2" maxlength="100">
                                <div class="error">{{nameError}}</div>
                            </div>

                            <div class="form-group">
                                <label>Description</label>
                                <textarea v-model.trim="vm.description" class="form-control"></textarea>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <div class="w-100 text-right">
                            <button v-if="!isGoal" type="button" class="btn btn-danger float-left" @click="emitDeleteCriterion">Delete</button>
                            <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                            <button type="submit" form="criterion-editor-form" class="btn btn-primary">Update</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>